// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_FILTER_MODAL_CLOSE = "Zavrie\u0165";
export const BZ_CATEGORY_TYPE_LABEL_FOR_CHILDREN = "Pre deti";
